import {useEffect} from 'react';

/* TODO: Using root.style.setProperty to override pulse variables inline on the <html> element because CSP blocks dynamically added <style> tags.
    Modifying the Content Security Policy (CSP) to allow inline styles ('unsafe-inline') is insecure and not advisable.
    Therefore, setting inline styles on <html> is the practical solution to dynamically update branding colors within CSP restrictions. */
export default function useUpdateThemeColors(branding, isBrandingLoaded) {
    const root = document.documentElement;
    const mode = root.getAttribute('data-mode');

    useEffect(() => {
        if (isBrandingLoaded && branding?.colors && branding?.colors[mode]) {
            const colorMapping = {
                'color-brand-interactive-primary-subdued': 'primary_subdued',
                'color-brand-interactive-primary-base': 'primary_base',
                'color-brand-interactive-primary-shade': 'primary_shade',
                'color-brand-interactive-secondary-subdued':
                    'secondary_subdued',
                'color-brand-interactive-secondary-base': 'secondary_base',
                'color-brand-interactive-secondary-shade': 'secondary_shade',
            };

            if (!mode || !branding.colors[mode]) {
                return;
            }

            Object.entries(colorMapping).forEach(([cssVar, brandColorKey]) => {
                const cssVarName = `--${cssVar}`;
                const cssValue = branding.colors[mode][brandColorKey];

                if (cssValue) {
                    root.style.setProperty(cssVarName, cssValue);
                }
            });
        }
    }, [branding, isBrandingLoaded, root, mode]);
}
